import { useEffect, useState } from "react";
import { listSystemSettings } from "../../services/apiClient.js";

// Read one System Setting (config/systemSettings.js) for feature-gating UI.
// Returns null while loading (or on error / a key the server didn't send) —
// treat null as "don't hide anything yet" so a blip never blanks the UI.
export function useSystemSetting(key) {
  const [value, setValue] = useState(null);
  useEffect(() => {
    let alive = true;
    listSystemSettings()
      .then((rows) => {
        if (!alive) return;
        const s = rows.find((r) => r.key === key);
        setValue(s ? !!s.value : null);
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, [key]);
  return value;
}
